// export const formatCurrency = (value) => {
//     return new Intl.NumberFormat('pt-BR', { currency: 'BRL' }).format(value);
// }

import Swal from "sweetalert2";

export const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export const swalCustom = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-primary order-0 btn-default-wl px-3 mb-2',
        cancelButton: 'btn order-1 btn-cancel-wl px-3'
    },
    buttonsStyling: false,
    reverseButtons: true
})